export default function useGoogleClientId() {
  return global.__AT_DATA__.googleClientId;
}
